export default __webpack_public_path__ + "static/media/c8.7c2dd0bb.png";